var Level;

(function (Level) {
  Level["L1"] = "L1";
  Level["L2"] = "L2";
  Level["L3"] = "L3";
  Level["L4"] = "L4";
  Level["L5"] = "L5";
  Level["L6"] = "L6";
  Level["L7"] = "L7";
  Level["L8"] = "L8";
  Level["L9"] = "L9";
})(Level || (Level = {}));

export { Level };
